import { NavList as NavListBase } from './nav-list';
import { NavListItem } from './nav-list-item';

export const NavList = Object.assign(NavListBase, {
	Item: NavListItem,
});
